module.exports = __webpack_public_path__ + "static/media/postcard2thumb.8707edc6.jpg";